import Patrol from "../fragments/patrol";

export default `
query QueryPatrolsByServiceProvider($serviceProviderId: String!, $from: Float, $to: Float, $after: String) {
  queryPatrolsByServiceProviderIdStartTimeIndex(
    serviceProviderId: $serviceProviderId, 
    from: $from, 
    to: $to, 
    after: $after
  ) {
    items ${Patrol}
    nextToken
  }
}
`;
